<template>
  <LayoutBaseContent :showBreadcrumbs="false" :layoutClass="$breakpoint.xs ? '' : undefined">
    <LayoutPanel>
      <template v-if="$breakpoint.mdAndUp || $route.name !== 'help'" #header>
        <div class="flex items-center justify-between" :class="{ rounded: $breakpoint.mdAndUp }">
          <h1 class="mb-0 text-xl font-medium">
            {{ $t('headMeta.helpAndInformation') }}
          </h1>

          <UtilButton to="/help" v-if="$route.name !== 'help' && $breakpoint.xs" color="primary" small>
            <FontAwesomeIcon :icon="faQuestionCircle" />
            View all help
          </UtilButton>
        </div>
      </template>

      <template #default>
        <div class="flex h-full">
          <div
            v-if="$breakpoint.mdAndUp || !compActiveSubNav"
            class="flex-shrink-0 max-w-md"
            :class="{ 'w-full': !compActiveSubNav }"
          >
            <div class="px-6 py-4 border-b border-gray-lighter">
              <h2 class="font-medium">{{ $t('titles.support') }}</h2>

              <p class="text-gray-darker">{{ $t('titles.forFurtherAssistance') }}:</p>

              <div class="mt-2">
                <FontAwesomeIcon :icon="faEnvelope" />

                <a href="mailto:support@sellmylivestock.co.uk">support@sellmylivestock.co.uk</a>
              </div>

              <div class="mt-1">
                <FontAwesomeIcon :icon="faPhone" />

                <a :href="`tel:${compHelpDeskDetails.tel}`" class="">{{ compHelpDeskDetails.tel }}</a>
              </div>
            </div>

            <LayoutPanelSubNav :items="compNav" sticky style="max-width: 380px">
              <template #footer>
                <p class="px-8 my-6 text-xs italic text-gray-500">
                  SellMyLivestock has a zero-tolerance policy towards sexual harassment and abusive behaviour of
                  our employees. We reserve the right to terminate services or partnerships in cases of
                  inappropriate conduct towards our employees or representatives.
                </p>
              </template>
            </LayoutPanelSubNav>
          </div>

          <div v-if="compActiveSubNav" class="flex-auto pb-8 border-l border-gray-lighter md:pb-0">
            <h2 class="account-settings-sub-header container-padding-x">
              {{ $route.meta.title }}
            </h2>

            <component
              :is="compActiveSubNav.component"
              v-bind="compActiveSubNav.props"
              class="mt-2 md:mt-0 container-padding"
            />
          </div>
        </div>
      </template>
    </LayoutPanel>
  </LayoutBaseContent>
</template>

<script>
import {
  faLightbulbOn,
  faEnvelope,
  faPhone,
  faQuestionCircle,
  faBookOpen
} from '@fortawesome/pro-regular-svg-icons'
import { generateMetaTags } from '@/lib/generate-meta'
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
import LayoutPanel from '@/components/layout/LayoutPanel'
import LayoutPanelSubNav from '@/components/layout/navigation/LayoutPanelSubNav'
import UtilButton from '@/components/utils/UtilButton'
import helpDeskProfile from '@/lib/helpers/helpdesk-profile'

export default {
  name: 'AccountSettings',
  components: {
    LayoutPanel,
    LayoutBaseContent,
    LayoutPanelSubNav,
    UtilButton
  },
  data() {
    return {
      faQuestionCircle,
      faEnvelope,
      faPhone
    }
  },
  mounted() {
    if (!this.compActiveSubNav && this.$breakpoint.mdAndUp) {
      this.$router.replace('/help/how-it-works')
    }
  },
  computed: {
    compActiveSubNav() {
      let activeSubNav = this.compNav.filter(nav => nav.pathName === this.$route.name)

      return activeSubNav ? activeSubNav[0] : null
    },

    compNav() {
      return [
        {
          text: 'How It Works',
          subText: 'Step-by-step guide to using SML',
          to: '/help/how-it-works',
          pathName: 'help-how-it-works',
          icon: faLightbulbOn,
          component: () => import('@/views/HelpHowWorks')
        },
        {
          text: 'Frequently Asked Questions',
          subText: 'Answers to common questions and issues',
          to: '/help/faqs',
          pathName: 'help-faqs',
          icon: faQuestionCircle,
          component: () => import('@/views/HelpFaqs')
        },
        {
          text: 'Terms and Privacy',
          subText: 'Read our terms and privacy policy',
          to: '/terms',
          pathName: 'terms',
          icon: faBookOpen
        }
        // {
        //   text: 'Guides & How-To',
        //   subText: 'Detailed feature demonstrations',
        //   to: '/help/guides',
        //   pathName: 'help-guides',
        //   icon: faBookSpells,
        //   component: () => import('@/views/HelpGuides')
        // },
        // {
        //   text: 'FarmPay Help',
        //   subText: 'Payments, finance and haulage help',
        //   to: '/help/farmpay',
        //   pathName: 'help-farmpay',
        //   image: require('@/assets/images/logos/services/farmpay-icon.png'),
        //   component: () => import('@/views/HelpFarmPay')
        // }
      ]
    },

    compHelpDeskDetails() {
      return helpDeskProfile
    }
  },
  head: {
    title() {
      return {
        inner: this.compActiveSubNav ? this.compActiveSubNav.text : this.$t('headMeta.helpAndInformation')
      }
    },
    meta() {
      return generateMetaTags({
        title: this.compActiveSubNav ? this.compActiveSubNav.text : this.$t('headMeta.helpAndInformation'),
        description: this.$route.meta.description
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.account-settings-sub-header {
  @apply font-medium text-xl border-b border-gray-lighter;
  height: 73px;
  line-height: 73px;
}

#app.smAndDown .account-settings-sub-header {
  display: none;
}
</style>
